import React from 'react';
import { Link } from 'react-router-dom';
import { getToken } from '../utils/Common';
import './NotFound.css';

export default function NotFound() {
  const isLoggedIn = !!getToken();

  return (
    <div className="not-found-page">
      <div className="not-found-panel">
        <p className="not-found-code">404</p>
        <h1 className="not-found-title">Page not found</h1>
        <p className="not-found-text">
          The page you&apos;re looking for doesn&apos;t exist or may have been moved.
        </p>
        <div className="not-found-actions">
          {isLoggedIn ? (
            <Link to="/dashboard" className="btn btn-brand-dark btn-compact">
              Go to Dashboard
            </Link>
          ) : (
            <Link to="/login" className="btn btn-brand-dark btn-compact">
              Log In
            </Link>
          )}
          <Link to="/" className="btn btn-brand-outline btn-compact">
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}
